import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollFederalEarningsSetup } from "../../components/PayrollFederalEarningsSetup/PayrollFederalEarningsSetup";
import { PayrollInsurableEarningsSetup } from "../../components/PayrollInsurableEarningsSetup";
import { PayrollPensionableEarningsSetup } from "../../components/PayrollPensionableEarningsSetup/PayrollPensionableEarningsSetup";
import { PayrollProvincialTaxableEarningsSetup } from "../../components/PayrollProvincialTaxableEarningsSetup";

// import { PayrollProvincialTaxableEarningsSetup } from "../../components/PayrollProvincialTaxableEarningsSetup/PayrollProvincialTaxableEarningsSetup";

export const PayrollProvincialTaxableEarningsSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll ProvincialTaxable Earnings Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/payrollFederalEarnings/list" },
        { text: "Payroll Provincial Taxable Earnings", navigateTo: "/company/payrollProvincialTaxableEarnings/setup" }
      ]}
      mainContents={<PayrollProvincialTaxableEarningsSetup />}
    />
  );
};
